import {Component, Input} from "@angular/core";

@Component({
    selector: "wbo-bi-selection-container",
    templateUrl: "./selection-container.component.html",
    styleUrls: ["./selection-container.component.scss"]

})
export class SelectionContainerComponent {

    @Input() title: string;

}
